module.exports = __webpack_public_path__ + "img/PAB.cd035b81.svg";